import { FetchTermsFrequencyResponse } from '@/types/api/report'

export const demoTermsFrequency: FetchTermsFrequencyResponse = [
  {
    Text: '咖啡',
    Value: 1,
  },
  {
    Text: '手沖',
    Value: 10,
  },
  {
    Text: '組',
    Value: 10,
  },
  {
    Text: '推薦',
    Value: 1,
  },
  {
    Text: '品質',
    Value: 25,
  },
  {
    Text: '好喝',
    Value: 135,
  },
  {
    Text: '香氣',
    Value: 3,
  },
  {
    Text: '自家',
    Value: 1,
  },
  {
    Text: '咖啡豆',
    Value: 3,
  },
  {
    Text: '磨豆機',
    Value: 6,
  },
  {
    Text: '口感',
    Value: 2,
  },
  {
    Text: '美味',
    Value: 23,
  },
  {
    Text: '享受',
    Value: 5,
  },
  {
    Text: '優惠',
    Value: 1,
  },
  {
    Text: '折扣',
    Value: 2,
  },
  {
    Text: '咖啡愛好者',
    Value: 1,
  },
  {
    Text: '開始',
    Value: 2,
  },
  {
    Text: '早晨',
    Value: 1,
  },
  {
    Text: '喜歡',
    Value: 19,
  },
  {
    Text: '精美',
    Value: 1,
  },
  {
    Text: '濃郁',
    Value: 3,
  },
  {
    Text: '熱愛',
    Value: 1,
  },
  {
    Text: '清晨',
    Value: 1,
  },
  {
    Text: '興奮',
    Value: 3,
  },
  {
    Text: '無限可能性',
    Value: 1,
  },
  {
    Text: '早安',
    Value: 3,
  },
  {
    Text: '提神',
    Value: 1,
  },
  {
    Text: '品味',
    Value: 3,
  },
  {
    Text: '愛上',
    Value: 64,
  },
  {
    Text: '藝術',
    Value: 1,
  },
  {
    Text: '開始',
    Value: 1,
  },
  {
    Text: '心情愉悅',
    Value: 1,
  },
  {
    Text: '體驗',
    Value: 3,
  },
  {
    Text: '自家沖泡',
    Value: 1,
  },
  {
    Text: '每天',
    Value: 1,
  },
  {
    Text: '品質',
    Value: 1,
  },
  {
    Text: '香醇',
    Value: 21,
  },
  {
    Text: '新鮮磨碎',
    Value: 5,
  },
  {
    Text: '清楚',
    Value: 45,
  },
  {
    Text: '真實',
    Value: 1,
  },
  {
    Text: '分享',
    Value: 1,
  },
  {
    Text: '價格',
    Value: 2,
  },
  {
    Text: '客觀',
    Value: 1,
  },
  {
    Text: '操作簡單',
    Value: 1,
  },
  {
    Text: '誠實',
    Value: 42,
  },
  {
    Text: '中立',
    Value: 2,
  },
]
